import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Callout } from '@fly/core';
import { downloadDesktopApp, openFlyApp } from '@fly/shared';
import { FlyCodeCopy } from '@fly/shared-ui';
import { closeDialog, openDialog, useAppDispatch } from '@fly/store';

export function useCiConfigureIde() {
  const dispatch = useAppDispatch();
  const isDesktopConnected = true;
  // const isDesktopConnected = useSelector(selectDesktopConnectionStatus);
  const { t } = useTranslation();

  return useCallback(
    (repositoryName: string, repositoryOwner: string) => {
      if (!isDesktopConnected) {
        dispatch(
          openDialog({
            title: t('app.registry.configure_ide_error_dialog.title', {
              defaultValue: 'Fly Desktop not connected',
            }),
            description: t(
              'app.registry.configure_ide_error_dialog.description',
              {
                defaultValue:
                  'To configure workflows with MCP, install Fly Desktop or launch it if already installed.',
              }
            ),
            width: '3',
            content: (
              <div className='mt-fly-4 flex flex-row justify-end gap-fly-3'>
                <Button
                  variant='soft'
                  color='neutral'
                  onClick={() => dispatch(closeDialog())}
                >
                  {t('app.common.actions.cancel', {
                    defaultValue: 'Cancel',
                  })}
                </Button>
                <Button
                  variant='solid'
                  color='accent'
                  onClick={() => {
                    downloadDesktopApp();
                    dispatch(closeDialog());
                  }}
                >
                  {t('app.registry.configure_ide_error_dialog.cta', {
                    defaultValue: 'Connect',
                  })}
                </Button>
              </div>
            ),
          })
        );
        return;
      }

      dispatch(
        openDialog({
          title: t('app.registry.configure_ide_success_dialog.title', {
            defaultValue: 'Configure Workflows with IDE',
          }),
          description: t(
            'app.registry.configure_ide_success_dialog.description',
            {
              defaultValue:
                'Use this prompt in your IDE chat to configure your workflows:',
            }
          ),
          width: '3',
          content: (
            <div>
              <FlyCodeCopy
                code={t('app.registry.configure_ide_success_dialog.code', {
                  defaultValue: 'Configure my workflows with Fly',
                })}
                className='mt-fly-6 w-full'
              />
              <Callout
                size='1'
                color='neutral'
                icon='info_circled'
                title={t('app.registry.configure_ide_success_dialog.callout', {
                  defaultValue:
                    'Make sure your Fly Desktop app MCP is configured',
                })}
                className='mt-fly-6 p-fly-3'
              />
              <div className='mt-fly-6 flex flex-row justify-end gap-fly-3'>
                <Button
                  variant='soft'
                  color='neutral'
                  onClick={() => dispatch(closeDialog())}
                >
                  {t('app.common.actions.cancel', {
                    defaultValue: 'Cancel',
                  })}
                </Button>
                <Button
                  variant='solid'
                  color='accent'
                  onClick={() => {
                    openFlyApp(
                      `configure?repository=${repositoryName}&owner=${repositoryOwner}`
                    );
                    dispatch(closeDialog());
                  }}
                >
                  {t('app.registry.configure_ide_success_dialog.cta', {
                    defaultValue: 'Go to IDE',
                  })}
                </Button>
              </div>
            </div>
          ),
        })
      );
    },
    [isDesktopConnected, t, dispatch]
  );
}
